import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

import "./ProfessionalDevelopment.css";

function ProfessionalDevelopment() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px 70px 0px"
      }
    );

    const elements = document.querySelectorAll(
      ".development-section .scroll-reveal"
    );

    elements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      elements.forEach((element) => {
        observer.unobserve(element);
      });

      observer.disconnect();
    };
  }, []);

  const activeTraining = [
    {
      title: "SOC Analyst Learning Path",
      provider: "LetsDefend",
      format: "Interactive SOC Simulation",
      status: "In Progress",
      description:
        "Developing practical experience in alert triage, phishing investigation, log analysis, escalation decisions, and incident-response workflows.",
      skills: [
        "Alert Triage",
        "Phishing Analysis",
        "Log Investigation",
        "Incident Handling"
      ]
    },
    {
      title: "SOC Level 1",
      provider: "TryHackMe",
      format: "Guided Blue-Team Labs",
      status: "In Progress",
      description:
        "Strengthening defensive security fundamentals through SIEM investigations, endpoint telemetry, Windows events, network analysis, and response exercises.",
      skills: [
        "SIEM Analysis",
        "Windows Events",
        "Endpoint Monitoring",
        "Network Security"
      ]
    }
  ];

  const completedSimulations = [
    {
      title: "Mastercard Cybersecurity Simulation",
      provider: "Forage",
      date: "June 2025",
      focus:
        "Phishing awareness, threat reporting, security communication, and user-focused risk reduction."
    },
    {
      title: "Tata Cybersecurity Simulation",
      provider: "Forage",
      date: "June 2025",
      focus:
        "Identity and access management concepts, access-control review, and security documentation."
    },
    {
      title: "Datacom Cybersecurity Simulation",
      provider: "Forage",
      date: "June 2025",
      focus:
        "Simulated cyberattack investigation, introductory incident analysis, and security risk assessment."
    }
  ];

  return (
    <section
      className="development-section"
      id="professional-development"
    >
      <Container>
        <header className="development-header scroll-reveal">
          <span className="development-eyebrow">
            Continuous Learning
          </span>

          <h2 className="development-title">
            Security <span>Training</span>
          </h2>

          <p className="development-subtitle">
            Practical blue-team learning focused on alert investigation,
            monitoring, identity security, incident response, and security
            operations.
          </p>
        </header>

        <div className="development-content">
          <section className="training-section scroll-reveal">
            <div className="training-section-heading">
              <div>
                <span className="training-section-number">
                  01
                </span>

                <div>
                  <span className="training-section-label">
                    Active Development
                  </span>

                  <h3>Current learning paths</h3>
                </div>
              </div>

              <p>
                Structured platforms used to practise realistic SOC
                investigation and defensive-security workflows.
              </p>
            </div>

            <div className="active-training-grid">
              {activeTraining.map((item) => (
                <article
                  key={item.title}
                  className="active-training-card"
                >
                  <div className="active-training-top">
                    <div>
                      <span className="training-provider">
                        {item.provider}
                      </span>

                      <span className="training-format">
                        {item.format}
                      </span>
                    </div>

                    <span className="training-status active">
                      <span aria-hidden="true" />
                      {item.status}
                    </span>
                  </div>

                  <h4>{item.title}</h4>

                  <p>{item.description}</p>

                  <div className="training-skills">
                    {item.skills.map((skill) => (
                      <span key={skill}>
                        {skill}
                      </span>
                    ))}
                  </div>
                </article>
              ))}
            </div>
          </section>

          <section className="training-section completed-section scroll-reveal">
            <div className="training-section-heading">
              <div>
                <span className="training-section-number">
                  02
                </span>

                <div>
                  <span className="training-section-label">
                    Completed Exercises
                  </span>

                  <h3>Professional simulations</h3>
                </div>
              </div>

              <p>
                Short practical simulations completed to reinforce
                security analysis, communication, access control, and risk
                awareness.
              </p>
            </div>

            <div className="completed-training-list">
              {completedSimulations.map((item, index) => (
                <article
                  key={item.title}
                  className="completed-training-item"
                >
                  <span className="completed-training-index">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <div className="completed-training-content">
                    <div className="completed-training-meta">
                      <span>{item.provider}</span>
                      <span>{item.date}</span>
                    </div>

                    <h4>{item.title}</h4>

                    <p>{item.focus}</p>
                  </div>

                  <span className="training-status completed">
                    Completed
                  </span>
                </article>
              ))}
            </div>

            {/* <p className="training-disclaimer">
              These simulations support practical learning and are listed
              separately from formal professional certifications.
            </p> */}
          </section>
        </div>
      </Container>
    </section>
  );
}

export default ProfessionalDevelopment;